import React from 'react';

import Select from 'corp/components/UI/Select';
import { RteTaskerTier } from '@scale/shared/remotasks/remotasksElite';

const SelectTierStatus = (props: $FIXME) => {
  const tierStatuses = Object.values(RteTaskerTier)
    .filter(tier => tier !== RteTaskerTier.NotApplicable)
    .map(value => ({ label: value, value }));
  return <Select {...props} options={tierStatuses} placeholder="Select Tier Status" />;
};
export default SelectTierStatus;
